import { drawingDataUri } from 'pages/main/cashbox/drawingGeometry'
// Chek chop etish hisob-kitoblari — Cheque80, ChequeA4 va ChequeWork uchun YAGONA manba.
//
// Ilgari bu funksiyalar Cheque80.js va ChequeA4.js da nusxalangan edi. Ikkalasi
// deyarli bir xil edi (farqi faqat `print_roll_quantity` — u A4 da yo'q edi),
// lekin nusxa qolsa ertaga biri tuzatilib ikkinchisi qolib ketardi: 80mm va A4
// chek bitta mahsulot uchun har xil miqdor ko'rsatardi. Shu sabab bu yerga
// chiqarildi — mantiq o'zgartirilmadi, faqat ko'chirildi.

export function toNumber(value) {
	return Number(value ?? 0) || 0
}

export function isPreparedProduct(product) {
	return product?.is_prepared === true || product?.is_prepared === 1 || product?.is_prepared === '1'
}

// Metr bilan sotiladigan (va metr bilan qaytariladigan) turlar: aksessuar(3),
// profnastil(4), tunikofon(5) — TAYYOR mahsulot bo'lmasa. Tayyor mahsulot dona bilan.
export function isMetrReturnProduct(product) {
	const productType = Number(product?.product_type ?? product?.product_type_id)
	return [3, 4, 5].includes(productType) && !isPreparedProduct(product)
}

export function getReturnQuantity(product) {
	if (isMetrReturnProduct(product)) {
		return toNumber(product?.metr || product?.quantity)
	}

	return toNumber(product?.quantity)
}

export function getPrintProduct(product) {
	const returnQuantity = getReturnQuantity(product)
	const returnedQuantity = Math.min(toNumber(product.original_returned_quantity), returnQuantity)
	const remainingQuantity = product.remaining_quantity !== undefined
		? toNumber(product.remaining_quantity)
		: Math.max(returnQuantity - returnedQuantity, 0)
	const printRollQuantity = isMetrReturnProduct(product)
		? toNumber(product.quantity)
		: returnQuantity
	const isTuni = toNumber(product.product_type) === 5 && !isPreparedProduct(product)
	/* CHIZMA eni katalognikidan ustun — sotuv (applyCheque), qaytarish (Return.js)
	   va cheklar ro'yxati (index()) aynan shu tartibda hisoblaydi. Bu yerda
	   katalog eni olinsa, chop etilgan chekdagi qaytarish summasi ro'yxatdagidan
	   ajralib qolardi. Eski qatorlarda `draw_width` NULL → o'zgarish yo'q. */
	const wTuni = toNumber(product.draw_width) > 0
		? toNumber(product.draw_width)
		: toNumber(product.width)
	const returnedAmount = product.returned_amount !== undefined
		? toNumber(product.returned_amount)
		: (isTuni && wTuni > 0
			? returnedQuantity * toNumber(product.sale_price) * wTuni
			: returnedQuantity * toNumber(product.sale_price))
	const originalSqM = toNumber(product.roll_metr) * toNumber(product.length)
	const remainingSqM = returnQuantity > 0 ? originalSqM * (remainingQuantity / returnQuantity) : 0

	// CHEK MAKETI: mahsulot qatori SOTILGAN (asl) miqdorni ko'rsatadi — qaytarish uni kamaytirmaydi.
	// Qaytarilgan miqdor/summa pastda ALOHIDA "Қайтариш" satrida chiqadi.
	return {
		...product,
		print_quantity: returnQuantity,
		print_roll_quantity: printRollQuantity,
		print_metr: returnQuantity,
		print_sq_m: originalSqM,
		print_total_price: toNumber(product.total_price),
		print_returned_sq_m: Math.max(originalSqM - remainingSqM, 0),
		print_returned_metr: returnedQuantity,
		print_returned_amount: returnedAmount,
		// Chekda ko'rsatiladigan eni — chizma bo'lsa o'shaniki (yuqoridagi `wTuni`)
		print_width: wTuni,
	}
}

/* ═══════════════════════════════════════════════════════════════════════════
   CHEKDAGI CHIZMA — kimga chop etilayotganiga qarab (2026-08-13)

   MUAMMO: `draw_png` bazaga BIR MARTA yoziladi va uchala chek (ish
   topshirig'i, mijoz 80 mm, mijoz A4) o'shani ishlatadi. Chizmaga o'lcham
   va burchak qo'shilgach, mijoz cheki ham sexning ko'rsatmasini ko'radigan
   bo'lib qoldi — burchak va rang tomoni mijozga kerak emas.

   YECHIM: chizma chop etish PAYTIDA `draw_json` dan qayta chiziladi.
     usta  → o'lcham + burchak + rang tomoni
     mijoz → faqat o'lcham (foydalanuvchi qarori)

   ⚠️ Eski qatorlarda `draw_json` bo'lmasligi mumkin (faqat `draw_png`) —
      u holda bazadagi rasmga qaytamiz, chizmasiz qolmasin.
═══════════════════════════════════════════════════════════════════════════ */
export function drawingForCheque(product, mode = 'worker') {
	if (!product) return null
	let dj = product.draw_json
	if (typeof dj === 'string') { try { dj = JSON.parse(dj) } catch (e) { dj = null } }

	if (!dj || !Array.isArray(dj.pts) || dj.pts.length < 2) {
		return product.draw_png || null
	}

	const forWorker = mode === 'worker'
	return drawingDataUri({
		pts: dj.pts,
		hem: dj.hem || {},
		colourTop: dj.colourTop !== false,
		coilHex: product.roll_colour || product.colour_hex || '#888',
		showDims: true,
		/* BURCHAK — faqat sexga. Mijoz chekida u shovqin (usta stanokdan biladi). */
		showAngles: forWorker,
		/* RANG TOMONI STRELKASI — HAMMA CHEKDA (2026-08-14, foydalanuvchi talabi).
		   Ilgari u `forWorker` bilan yopilgan edi va mijoz/sotuvchi chekida
		   (Cheque80 «client», ChequeA4 «client») umuman chiqmasdi.
		   Nega kerak: strelka qaysi tomon BO'YALGANini ko'rsatadi — bu mijoz
		   bilan tasdiqlanadigan ma'lumot, faqat sexning ishi emas. Sotuvchi
		   chekni ko'rsatib «rangli tomoni shu yoqda» deb kelishadi. */
		showColour: true,
	}) || product.draw_png || null
}
